export const getObjectFromArray = (value, array, key) => {
  let obj = array.find(val => {
    if (val[key] && value) {
      return val[key]?.toLowerCase() == value.toLowerCase();
    } else {
      return null;
    }
  });
  return obj;
};

export const createNestedArray = (list, parentIdKey, id) => {
  let parentChildMap = {};
  let nestedList = [];
  for (let i = 0; i < list.length; i++) {
    if (list[i][parentIdKey]) {
      let parent = Number(list[i][parentIdKey]);
      if (!parentChildMap[parent]) {
        parentChildMap[parent] = [];
      }
      parentChildMap[parent].push(list[i]);
    }
  }
  for (let i = 0; i < list.length; i++) {
    if (parentChildMap[list[i].id]) {
      list[i].nestedData = parentChildMap[list[i].id];
    }
  }
  nestedList = list.filter(item => !item[parentIdKey]);
  return nestedList[0].nestedData;
};

export const createColumnsPayload = (data) => {
  return data.map((item) => {
    let isAGroupByColumn = item?.isAGroupByColumn == false ? false : true;
    return {
      dataType: "text",
      tier: item?.type,
      tierOrder: item?.level,
      sourceSys: "planit",
      columnName: item?.columnName,
      isPartOfTierId: item.uniqueChecked,
      isMinSetColumn: item.isMinSetColumn || false,
      isAGroupByColumn: isAGroupByColumn,
      isPartOfDisplayName: item.isPartOfDisplayName,
      sourceColumnName: item?.sourceColumnName,
    };
  });
};

export const swapJson = (json) => {
  var ret = {};
  for (var key in json) {
    if (Array.isArray(json[key])) {
      json[key].forEach(item => {
        ret[item] = key;
      });
    } else {
      ret[json[key]] = key;
    }
  }
  return ret;
};

export const findObjectByIdInNestedDataInAggridData = (data, targetId) => {
  for (let item of data) {
    if (item.id.toString() === targetId.toString()) {
      return item;
    }
    if (item.nestedData && Array.isArray(item.nestedData)) {
      const found = findObjectByIdInNestedDataInAggridData(item.nestedData, targetId);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

export const transformAmounts = (obj) => {
  const transformedObj = { ...obj };
  Object.keys(transformedObj).forEach(key => {
    if (typeof transformedObj[key] === 'number') {
      transformedObj[key] = parseFloat(transformedObj[key]);
    }
  });
  return transformedObj;
};

export const disableHierarchyPublishButton = (state, tableRowData, existingColumnsIsUpdated, enableButton = false) => {
  const templateNameIsEmpty = state.templateName?.trim() === '';
  const templateNameIsUpdated = (tableRowData?.templateName !== state.templateName);
  const endDateIsUpdated = (state.endDate && tableRowData?.campaignEnd !== state.endDate);
  const startDateIsUpdated = (state.startDate && tableRowData?.campaignStart !== state.startDate);
  const someColumnNameIsEmpty = state.hierarchyObjectData?.some(item => item.columnName === '');
  const someCustomColumnNameIsEmpty = state.customColumnsData?.some(item => item.columnName === '');
  const planIdsIsUpdated = ((tableRowData?.planIds || [])?.length === state.planIds?.length) && ((tableRowData?.planIds || [])?.every(item => state.planIds.includes(item)));
  let disabled = false;
  if ((enableButton && tableRowData?.mediaOpsState === "Saved") || templateNameIsUpdated || state.hierarchyObjectData?.length || existingColumnsIsUpdated || startDateIsUpdated || endDateIsUpdated)
    disabled = templateNameIsEmpty || someColumnNameIsEmpty;
  else if (templateNameIsEmpty || someColumnNameIsEmpty || someCustomColumnNameIsEmpty || planIdsIsUpdated)
    disabled = true;
  return disabled;
};

export const removeDuplicateChildItems = (taxonomyData) => {
  if (!taxonomyData?.length) {
    return taxonomyData;
  }
  const result = taxonomyData.map(taxonomy => {
    if (!taxonomy?.fields?.length) {
      return taxonomy;
    }
    return {
      ...taxonomy,
      fields: taxonomy.fields.map(field => {
        if (!field?.fielditems?.length) {
          return field;
        }
        return {
          ...field,
          fielditems: field.fielditems.map(fieldItem => {
            if (!fieldItem?.childitems?.length) {
              return fieldItem;
            }
            const uniqueChildItems = [
              ...new Map(
                fieldItem.childitems.map(item => [item.Id, item])
              ).values()
            ];
            return {
              ...fieldItem,
              childitems: uniqueChildItems
            };
          })
        };
      })
    };
  });
  return result;
};

export const convertSingleToDoubleQuotes = (input) => {
  const placeholder = '___DOUBLE_QUOTE_PLACEHOLDER___';
  input = input.replaceAll('"', placeholder);
  input = input.replace(/'([^']*?)'\s*:/g, '"$1":');
  input = input.replace(/:\s*'([^']*?)'([,\]}])/g, ':"$1"$2');
  input = input.replaceAll(placeholder, '"');
  return input;
};

export const sanitizeStringToValidJson = (input) => {
  let data = convertSingleToDoubleQuotes(input);
  data = data.replace(/None/g, 'null');
  data = data.replace(/False/g, 'false');
  data = data.replace(/True/g, 'true');
  return data;
};

export const sanitizeCookieName = (name) => {
  return name.replace(/[^a-zA-Z0-9_-]/g, '');
};

export const checkForClientCodeAndBuyingSystem = (systemParams, campaignClientCode) => {
  const clientCodes = systemParams?.data?.clientCode || [];
  for (let i = 0; i < clientCodes.length; i++) {
    if (clientCodes[i]?.clientCode === campaignClientCode) {
      if (['MediaOcean', 'MediaOcean-CA'].includes(clientCodes[i]?.buyingSystem)) {
        return true;
      }
      break;
    }
  }
  return false;
};
